import { BookmarkElement } from "../../models/bookmark-element.model";
import { BookmarkElementsOperator } from "./bookmark-elements.operator";
import { Bookmark } from "../../models/bookmark.model";
import { DxChartComponent } from "devextreme-angular";
import { fromEvent } from "rxjs";
import { isFunction } from "src/app/helpers/type-utils";
import { LegendClickEvent } from "devextreme/viz/chart_types";

/**
 *
 */
export class DxChartBookmarkElementsOperator extends BookmarkElementsOperator {

	// Cache to store visibility for each series.
	private _seriesVisibilityCache: Map<string, boolean> = new Map();

	public override applyBookmarkElements(bookmarkElements: BookmarkElement[]): void {
		const dxChartComponent: DxChartComponent = isFunction(this.dxChartComponent) ? this.dxChartComponent() : this.dxChartComponent;

		// Use `beginUpdate` and `endUpdate` in order to prevent redraw.
		dxChartComponent.instance.beginUpdate();

		for (let series of dxChartComponent.instance.getAllSeries()) {
			let key = series.name;

			let visibilityObject: BookmarkElement = bookmarkElements.find(element => element.key === key);

			if (visibilityObject) {
				if (visibilityObject.value === 'true') {
					series.show();
				} else {
					series.hide();
				}
			}

			this._seriesVisibilityCache.set(key, series.isVisible());
		}

		dxChartComponent.instance.endUpdate();
	}

	public override prepareBookmarkElements(bookmark: Bookmark): BookmarkElement[] {
		const dxChartComponent: DxChartComponent = isFunction(this.dxChartComponent) ? this.dxChartComponent() : this.dxChartComponent;

		const elements: BookmarkElement[] = [];

		// Assume series are stored in `chart.series`
		for (let series of dxChartComponent.instance.getAllSeries()) {
			let key = series.name;
			let value = series.isVisible();

			elements.push(
				new BookmarkElement(
					undefined,
					bookmark.bookmarkId,
					key,
					value.toString(),
					this.id
				)
			);
		}

		return elements;
	}

	public static readonly DEFAULT_ID_PART: number = 2;

	/**
	 *
	 * @param id Responsible for identifying multiple `BookmarkElement`s that this operator controls.
	 */
	constructor(
		id: string,
		public dxChartComponent: DxChartComponent | (() => DxChartComponent),
	) {
		super(id);

		const dxChartComponentResolved: DxChartComponent = isFunction(this.dxChartComponent) ? this.dxChartComponent() : this.dxChartComponent;

		// When the user toggles a series, update the cache.
		fromEvent(
			dxChartComponentResolved.instance,
			'legendClick'
		).subscribe(
			(evt: LegendClickEvent) => {
				const key = evt.target.name;

				this._seriesVisibilityCache.set(key, evt.target.isVisible());
			}
		);

		// On each redraw event we need to reset settings for the series to our cached valued that we have applied before.
		// This way the chart won't lose series settings each time its data gets updated or the chart is redrawn.
		fromEvent(
			dxChartComponentResolved.instance,
			'drawn'
		).subscribe(
			() => {
				setTimeout(
					() => {
						for (let series of dxChartComponentResolved.instance.getAllSeries()) {
							let key = series.name;

							if (this._seriesVisibilityCache.has(key)) {
								if (this._seriesVisibilityCache.get(key)) {
									series.show()
								} else {
									series.hide();
								}
							}
						}
					},
					null
				);
			}
		);

		// // A POSSIBLE SOLUTION IF WE WANT TO WAIT FOR THE 'legendClick' to occur until timer runs out.
		// fromEvent(dxChartComponentResolved.instance, 'drawn')
		// .pipe(
		// 	delayWhen(() =>
		// 	race(
		// 		// Wait for the next legendClick event (if it occurs)
		// 		fromEvent(dxChartComponentResolved.instance, 'legendClick').pipe(take(1)),
		// 		// Fallback: wait for 10ms if no legendClick happens
		// 		timer(10)
		// 	)
		// 	)
		// )
		// .subscribe(() => {
		// 	for (let series of dxChartComponentResolved.instance.getAllSeries()) {
		// 	const key = series.name;
		// 	if (this._seriesVisibilityCache.has(key)) {
		// 		this._seriesVisibilityCache.get(key) ? series.show() : series.hide();
		// 	}
		// 	}
		// });
	}
}
